import * as React from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickAriaProps, pickDataProps } from "../../interfaces/commonProps.mjs.mjs";
import { StyledText } from "./Text.styles.mjs.mjs";
export const Text = React.forwardRef(function Text({ 'data-testid': testingId, as = 'p', children, className, id, variant = 'copy1', weight = 'normal', role, tint, ...restProps }, ref) {
    const passthroughProps = {
        'data-testid': testingId,
        as,
        className,
        id,
        outerSpacing: useSpacing(restProps),
        variant,
        weight,
        role,
        tint,
    };
    return (React.createElement(StyledText, { ref: ref, ...passthroughProps, ...pickAriaProps(restProps), ...pickDataProps(restProps) }, children));
});
//# sourceMappingURL=Text.mjs.mjs.map